import React from 'react';
import { ImageGallery, ImageGalleryProps } from 'acscp/components/common/imageGallery';
import { BookingImage } from 'acscp/store';
import { CroppedImage } from 'acscp/components/common/croppedImage';

interface QuoteImageGalleryProps extends ImageGalleryProps {
    bookingImages: BookingImage[];
}

const QuoteImageGallery: React.SFC<QuoteImageGalleryProps>
    = ({ title, onClose, onFullscreen, bookingImages, showCloseButton , showDisclaimer = false}) => (
    <ImageGallery
        title={title}
        showCloseButton={showCloseButton}
        onClose={onClose}
        onFullscreen={onFullscreen}
        showDisclaimer={showDisclaimer}
    >
        {
            bookingImages.length
                ?
                    bookingImages.map((img, i) => (
                        <div key={i}>
                            <CroppedImage ratio={16 / 9} src={img.url} />
                        </div>
                    ))
                :
                    <div>
                        <CroppedImage ratio={16 / 9} />
                    </div>
        }
    </ImageGallery>
);

export { QuoteImageGallery };
export type { QuoteImageGalleryProps };
